import { render } from "./Default.vue?vue&type=template&id=0ed788b6"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
script.render = render

export default script